import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  Link,
  TextField,
  Typography,
  Alert,
  Snackbar
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";
import { verifyOTP, resendOTP } from "../../services/loanService";
import { useSelector } from "react-redux";
import { ip } from "../../Store/userSlice";
import { assetPath } from "../../utils/constants";

const OTPVerification = ({
  showOTPVerification,
  setShowOTPVerification,
  showMobileOTP,
  requestData,
  onVerificationSuccess,
  onVerificationError
}) => {
  const theme = useTheme();
  const { handleSubmit } = useForm();
  const [otpError, setOtpError] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
const IpAddress = useSelector(ip)
  const [otp, setOtp] = useState({
    mobile: ["", "", "", ""],
    email: ["", "", "", ""],
  });

  const [timers, setTimers] = useState({
    mobile: 60,
    email: 60
  });

  const [resendVisible, setResendVisible] = useState({
    mobile: false,
    email: false
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  useEffect(() => {
    if (showOTPVerification) {
      setSnackbar({
        open: true,
        message: "OTP sent successfully",
        severity: "success"
      });
    }
  }, [showOTPVerification]);

  useEffect(() => {
    const intervals = {};

    if (timers.mobile > 0) {
      intervals.mobile = setInterval(() => {
        setTimers(prev => ({
          ...prev,
          mobile: prev.mobile - 1
        }));
      }, 1000);
    } else {
      setResendVisible(prev => ({
        ...prev,
        mobile: true
      }));
    }

    if (timers.email > 0) {
      intervals.email = setInterval(() => {
        setTimers(prev => ({
          ...prev,
          email: prev.email - 1
        }));
      }, 1000);
    } else {
      setResendVisible(prev => ({
        ...prev,
        email: true
      }));
    }

    return () => {
      if (intervals.mobile) clearInterval(intervals.mobile);
      if (intervals.email) clearInterval(intervals.email);
    };
  }, [timers.mobile, timers.email]);

  const handleChange = (event, index, type) => {
    const value = event.target.value.replace(/[^0-9]/g, "").slice(0, 1);
    const key = event.nativeEvent.inputType; // Detect input type (Backspace or normal input)
  
    setOtp((prevOtp) => {
      const updatedOtp = { ...prevOtp, [type]: [...prevOtp[type]] };
  
      if (key === "deleteContentBackward") {
        if (index > 0) {
          // Only allow backspace to clear if the index is greater than 0
          if (updatedOtp[type][index] !== "") {
            updatedOtp[type][index] = "";
            setTimeout(() => document.getElementById(`${type}-otp-${index - 1}`).focus(), 10);
          } else {
            updatedOtp[type][index - 1] = "";
            setTimeout(() => document.getElementById(`${type}-otp-${index - 1}`).focus(), 10);
          }
        } else {
          // Skip clearing and focus movement at 0th index
          updatedOtp[type][index] = "";
          setTimeout(() => document.getElementById(`${type}-otp-${index}`).focus(), 10);
        }
      } else {
        // Update current field and move to next if there's a value
        updatedOtp[type][index] = value;
        if (value && index < updatedOtp[type].length - 1) {
          setTimeout(() => document.getElementById(`${type}-otp-${index + 1}`).focus(), 10);
        }
      }
  
      return updatedOtp;
    });
  };

  const onSubmit = async () => {
    const enteredMobileOtp = otp?.mobile?.join('');
    const enteredEmailOtp = otp?.email?.join('');

    if (!enteredMobileOtp || enteredMobileOtp.length < 4) {
      setOtpError(true);
      setError("Please enter the complete Mobile OTP");
      setSnackbar({
        open: true,
        message: "Please enter the complete Mobile OTP",
        severity: "error"
      });
      return;
    }

    if ((!enteredEmailOtp || enteredEmailOtp.length < 4) && !showMobileOTP && requestData?.email) {
      setOtpError(true);
      setError("Please enter the complete Email OTP");
      setSnackbar({
        open: true,
        message: "Please enter the complete Email OTP",
        severity: "error"
      });
      return;
    }
  
    setOtpError(false);
    if (!requestData) {
      setError("Borrower data not found. Please try again.");
      setSnackbar({
        open: true,
        message: "Borrower data not found. Please try again.",
        severity: "error"
      });
      return;
    }

    const verifyOtpRequest = {
      mobileNumber: requestData.mobileNumber,
      mobileOtp: enteredMobileOtp
    };

    if (requestData.email) {
      verifyOtpRequest.email = requestData.email;
      verifyOtpRequest.emailOtp = enteredEmailOtp;
    }

    try {
      const response = await verifyOTP(verifyOtpRequest);
      if (response?.responseCode === 200) {
        if (response?.responseMessage === "OTP verified") {
          setSuccess("OTP verified successfully");
          setSnackbar({
            open: true,
            message: "OTP verified successfully",
            severity: "success"
          });
          onVerificationSuccess();
          handleClose();
        } else if (response?.responseMessage === "OTP not verified") {
          setError("OTP not verified. Please try again.");
          setSnackbar({
            open: true,
            message: "OTP not verified. Please try again.",
            severity: "error"
          });
          onVerificationError("OTP not verified. Please try again.");
        } else {
          setSuccess("OTP verified successfully");
          setSnackbar({
            open: true,
            message: "OTP verified successfully",
            severity: "success"
          });
          onVerificationSuccess();
          handleClose();
        }
      } else {
        setError(response?.responseMessage || "OTP verification failed");
        setSnackbar({
          open: true,
          message: response?.responseMessage || "OTP verification failed",
          severity: "error"
        });
        onVerificationError(response?.responseMessage || "OTP verification failed");
      }
    } catch (err) {
      setError("Oops! Something went wrong.");
      setSnackbar({
        open: true,
        message: "Oops! Something went wrong.",
        severity: "error"
      });
      onVerificationError("Oops! Something went wrong.");
      console.error('Verify OTP error:', err);
    }
  };

  const handleResend = (type) => {
    if (!requestData) {
      setError("Borrower data not found. Please try again.");
      setSnackbar({
        open: true,
        message: "Borrower data not found. Please try again.",
        severity: "error"
      });
      onVerificationError("Borrower data not found. Please try again.");
      return;
    }

    const payload = {
      mobileNumber: requestData.phoneNumber || requestData.mobileNumber,
      ip: requestData.ip || IpAddress,
      longitude: requestData.longitude || '',
      latitude: requestData.latitude || '',
      ...(requestData.email && { email: requestData.email })
    };

    resendOTP(payload)
      .then((res) => {
        if (res?.responseCode === 200) {
          setSnackbar({
            open: true,
            message: "OTP sent successfully",
            severity: "success"
          });
          setOtp(prev => ({
            ...prev,
            [type]: ["", "", "", ""]
          }));
          setTimers(prev => ({
            ...prev,
            [type]: 30
          }));
          setResendVisible(prev => ({
            ...prev,
            [type]: false
          }));
        } else {
          setSnackbar({
            open: true,
            message: res.responseMessage || "Failed to send OTP",
            severity: "error"
          });
          onVerificationError(res.responseMessage || "Failed to send OTP");
        }
      })
      .catch((e) => {
        setSnackbar({
          open: true,
          message: "Failed to send OTP",
          severity: "error"
        });
        onVerificationError("Failed to send OTP");
        console.log(e, "error");
      });
  };

  const handleClose = () => {
    setShowOTPVerification(false);
    setOtp({ mobile: ["", "", "", ""], email: ["", "", "", ""] });
    setError(null);
    setSuccess(null);
    setOtpError(false);
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  return (
    <>
    <Dialog
      open={showOTPVerification}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "20px",
          overflow: "hidden",
          maxWidth: "1200px",
          width: "90%",
          height: "auto",
          maxHeight: "90vh"
        },
      }}
    >
      <DialogContent sx={{ padding: 0, position: "relative", height: "100%" }}>
        <CloseIcon
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: "1rem",
            right: "1rem",
            cursor: "pointer",
            zIndex: 1,
            color: "#003A91",
          }}
        />
        <Grid container sx={{ height: "100%" }}>
          <Grid
            item
            xs={12}
            sm={5}
            sx={{
              display: { xs: "none", sm: "flex" },
              background: `url('${assetPath("fintech.png")}')`,
              backgroundPosition: "left top",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              height: "100%",
              minHeight: "600px",
              maxHeight: "100vh",
            }}
          />
          {/* Right Side Form */}
          <Grid
            item
            xs={12}
            sm={7}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              padding: "2rem",
              position: "relative",
              [theme.breakpoints.down("sm")]: { padding: "1rem" },
              maxHeight: "90vh",
              overflowY: "auto"
            }}
          >
            {/* Logo at Top Center */}
            <Box sx={{ textAlign: "center", mb: 3 }}>
              <img
                src={assetPath("dequiLogo.png")}
                alt="Logo"
                style={{ width: "150px" }}
              />
            </Box>
            <Typography
              variant="h6"
              sx={{
                color: "#003A91",
                fontWeight: 700,
                marginBottom: "0.5rem",
                display: "flex",
              }}
            >
              OTP Verification
            </Typography>
            <Typography
              sx={{
                color: "#333333",
                fontSize: "0.8rem",
                fontWeight: 200,
                marginBottom: "1rem",
                fontStyle: "italic",
              }}
            >
              Enter the verification code sent via SMS on your{" "}
              <Box component="span" sx={{ fontWeight: "bold" }}>
              Mobile Number
              </Box>
              .
            </Typography>
            <Box sx={{ display: "flex", gap: 3, marginBottom: "0.6rem" }}>
              {otp.mobile.map((digit, index) => (
                <TextField
                  key={index}
                  id={`mobile-otp-${index}`}
                    variant="outlined"
                  error={otpError && digit === ""}
                  inputProps={{
                    maxLength: 1,
                    style: {
                      textAlign: "center",
                      fontSize: "1.5rem",
                      width: "40px",
                    },
                  }}
                  value={digit}
                  onChange={(e) => handleChange(e, index, "mobile")}
                />
              ))}
            </Box>
            
              <Box sx={{ 
                display: "flex", 
                justifyContent: "flex-end", 
                marginBottom: "1rem", 
                fontSize: "0.75rem" 
              }}>
                {!resendVisible.mobile ? (
                <Typography sx={{ 
                    fontSize: "0.75rem", 
                    fontStyle: "italic", 
                    color: "text.secondary" 
                  }}>
                  Resend code in {timers.mobile} seconds
              </Typography>
            ) : (
              <Link 
                    onClick={() => handleResend("mobile")} 
                sx={{ 
                      cursor: "pointer", 
                  fontSize: "0.8rem",
                      textDecoration: "none", 
                      color: "#003A91",
                      fontWeight: "600",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      '&:hover': {
                        backgroundColor: "rgba(0, 58, 145, 0.08)",
                        textDecoration: "underline"
                      }
                    }}
                  >
                    Resend Code
                  </Link>
                )}
              </Box>
            
            {requestData?.email && (
              <>
                <Typography
                  sx={{
                    color: "#333333",
                    fontSize: "0.8rem",
                    fontWeight: 200,
                    marginBottom: "1rem",
                    fontStyle: "italic",
                    marginTop: "0.5rem",
                  }}
                >
                  Enter the verification code we just sent on your{" "}
                  <Box component="span" sx={{ fontWeight: "bold" }}>
                    email ID
                  </Box>
                  .
                </Typography>
                <Box sx={{ display: "flex", gap: 3, marginBottom: "0.6rem" }}>
                  {otp.email.map((digit, index) => (
                    <TextField
                      key={index}
                      id={`email-otp-${index}`}
                      variant="outlined"
                      error={otpError && digit === ""}
                      inputProps={{
                        maxLength: 1,
                        style: {
                          textAlign: "center",
                          fontSize: "1.5rem",
                          width: "40px",
                        },
                      }}
                      value={digit}
                      onChange={(e) => handleChange(e, index, "email")}
                    />
                  ))}
                </Box>
                
                <Box sx={{ 
                  display: "flex", 
                  justifyContent: "flex-end", 
                  marginBottom: "1rem", 
                  fontSize: "0.75rem" 
                }}>
                  {!resendVisible.email ? (
                    <Typography sx={{ 
                      fontSize: "0.75rem", 
                      fontStyle: "italic", 
                      color: "text.secondary" 
                    }}>
                      Resend code in {timers.email} seconds
                    </Typography>
                  ) : (
                    <Link 
                      onClick={() => handleResend("email")} 
                      sx={{ 
                        cursor: "pointer", 
                        fontSize: "0.8rem",
                        textDecoration: "none", 
                        color: "#003A91",
                        fontWeight: "600",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        '&:hover': {
                          backgroundColor: "rgba(0, 58, 145, 0.08)",
                          textDecoration: "underline"
                        }
                      }}
                    >
                      Resend Code
                    </Link>
                  )}
                </Box>
              </>
            )}
            
            <Button
                onClick={onSubmit}
              variant="contained"
                color="primary"
              fullWidth
              sx={{
                  marginTop: "1rem",
                  padding: ".75rem 0",
                  borderRadius: "10px",
                  background: "linear-gradient(90deg, #003A91 0%, #0055c7 100%)",
                textTransform: "none",
                  boxShadow: "0 4px 15px rgba(0, 58, 145, 0.2)",
                  fontSize: "1rem",
                  "&:hover": {
                    background: "linear-gradient(90deg, #002d6f 0%, #0049a8 100%)",
                  },
              }}
            >
                Submit
            </Button>

              <Box sx={{ display: "flex", justifyContent: "center", mt: 1.5 }}>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontStyle: "italic",
                    color: "text.secondary",
                  }}
                >
                  Don't share OTP with anyone
                </Typography>
              </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
      
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ position: 'fixed', zIndex: 9999 }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity}
          sx={{ 
            width: '100%',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default OTPVerification; 